import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function QsaHsaDfiDataAnalyticsTable() {
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 700 }}>Patient Name</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Patient Age</TableCell>
            <TableCell style={{ fontWeight: 700 }}>MPID</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Spouse Name</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Spouse Age</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Name of Test</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Date</TableCell>
            <TableCell style={{ fontWeight: 700 }}>
              No. of Days Abstinence
            </TableCell>
            <TableCell style={{ fontWeight: 700 }}>
              Sample Complete/Incomplete
            </TableCell>
            <TableCell style={{ fontWeight: 700 }}>Appearance</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Liquefaction Time</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Viscosity</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Volume</TableCell>
            <TableCell style={{ fontWeight: 700 }}>pH</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Agglutination</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Round Cell Count</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Sperm Count</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Total Count</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Motility (%)</TableCell>
            <TableCell style={{ fontWeight: 700 }}>a. Progressive</TableCell>
            <TableCell style={{ fontWeight: 700 }}>
              b. Non-Progressive
            </TableCell>
            <TableCell style={{ fontWeight: 700 }}>c. Immotile</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Viability (%live)</TableCell>
            <TableCell style={{ fontWeight: 700 }}>Morphology</TableCell>
            <TableCell style={{ fontWeight: 700 }}>
              Sperm DNA Fragmentation Index (DFI)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                {item.patientGender === 'male'
                  ? item.patientName
                  : item.partnerName}
              </TableCell>
              <TableCell>
                {item.patientGender === 'male'
                  ? item.patientAge
                  : item.partnerAge}
              </TableCell>
              <TableCell>{item.upid}</TableCell>
              <TableCell>
                {item.patientGender === 'male'
                  ? item.partnerName
                  : item.patientName}
              </TableCell>
              <TableCell>
                {item.patientGender === 'male' ? item.partnerAge : item.Age}
              </TableCell>
              <TableCell>{item.type}</TableCell>
              <TableCell sx={{ minWidth: '160px' }}>
                {new Date(item.createdAt).toLocaleDateString('en-uk')}
              </TableCell>
              <TableCell>
                {item.patientDetails.abstinenceDays === ''
                  ? 'N/A'
                  : item.patientDetails.abstinenceDays}
              </TableCell>
              <TableCell>{item.patientDetails.sample}</TableCell>
              <TableCell>
                {item.seminalFluidAnalysis.appearance === ''
                  ? 'N/A'
                  : item.seminalFluidAnalysis.appearance}
              </TableCell>
              <TableCell>
                {item.seminalFluidAnalysis.liquefactionTime === ''
                  ? 'N/A'
                  : item.seminalFluidAnalysis.liquefactionTime}
              </TableCell>
              <TableCell>
                {item.seminalFluidAnalysis.viscosity === ''
                  ? 'N/A'
                  : item.seminalFluidAnalysis.viscosity}
              </TableCell>
              <TableCell>
                {item.seminalFluidAnalysis.volume === ''
                  ? 'N/A'
                  : item.seminalFluidAnalysis.volume}
              </TableCell>
              <TableCell>
                {item.seminalFluidAnalysis.ph === ''
                  ? 'N/A'
                  : item.seminalFluidAnalysis.ph}
              </TableCell>
              <TableCell>
                {item.seminalFluidAnalysis.agglutination === ''
                  ? 'N/A'
                  : item.seminalFluidAnalysis.agglutination}
              </TableCell>
              <TableCell>
                {item.seminalFluidAnalysis.roundCellCount === ''
                  ? 'N/A'
                  : item.seminalFluidAnalysis.roundCellCount}
              </TableCell>
              <TableCell>
                {item.spermAnalysis.spermCount === ''
                  ? 'N/A'
                  : item.spermAnalysis.spermCount}
              </TableCell>
              <TableCell>
                {item.spermAnalysis.totalCount === ''
                  ? 'N/A'
                  : item.spermAnalysis.totalCount}
              </TableCell>
              <TableCell>
                {item.spermAnalysis.motility === ''
                  ? 'N/A'
                  : item.spermAnalysis.motility}
              </TableCell>
              <TableCell>
                {item.spermAnalysis.progression === ''
                  ? 'N/A'
                  : item.spermAnalysis.progression}
              </TableCell>
              <TableCell>
                {item.spermAnalysis.nonProgression === ''
                  ? 'N/A'
                  : item.spermAnalysis.nonProgression}
              </TableCell>
              <TableCell>
                {item.spermAnalysis.immotile === ''
                  ? 'N/A'
                  : item.spermAnalysis.immotile}
              </TableCell>
              <TableCell>
                {item.spermAnalysis.viability === ''
                  ? 'N/A'
                  : item.spermAnalysis.viability}
              </TableCell>
              <TableCell>
                {item.spermAnalysis.morphologyNormal === ''
                  ? 'N/A'
                  : item.spermAnalysis.morphologyNormal}
              </TableCell>
              <TableCell>
                {item.dfiDetails
                  ? item.dfiDetails.dnaFregmentationIndex === ''
                    ? 'N/A'
                    : item.dfiDetails.dnaFregmentationIndex
                  : 'N/A'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default QsaHsaDfiDataAnalyticsTable;
